export * from './image-upload.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-upload/index.ts